module.exports = __webpack_public_path__ + "static/media/tor3.5d651be1.svg";